export default __webpack_public_path__ + "static/media/disnep.8fba2954.png";